import {useMutation} from '@tanstack/react-query';

import {putHealthRescheduleAppointments} from '../../services/putHealthRescheduleAppointments';

export const usePutHealthRescheduleAppointmentsMutation = () => {
	return useMutation({
		mutationFn: putHealthRescheduleAppointments,
	});
};
